//@ts-nocheck

import api from "./api";
import { ENV } from "../utils/constants";

export const createFbUser = async (dataUser): Promise<any> => {
  try {
    const { data } = await api.post(
      `social-networks-v2-${ENV}/users`,
      dataUser
    );
    return data;
  } catch (err) {
    return err;
  }
};

export const updateFbUser = async (dataUser): Promise<any> => {
  try {
    const { data } = await api.put(`social-networks-v2-${ENV}/pages`, dataUser);
    return data;
  } catch (err) {
    return err;
  }
};

export const listFbPages = async (dataUser): Promise<any> => {
  try {
    const { data } = await api.get(`social-networks-v2-${ENV}/pages`, dataUser);
    return data;
  } catch (err) {
    return err;
  }
};
